module.exports = __webpack_public_path__ + "static/media/hero_about-resized-4k-center-cropped.f2e4a002.jpg";